import { DiscussionContentItem, DiscussionMessage } from '@front-app/services/GroupsApi/DiscussionModel';
import { CurrentUserStore } from '@front-app/store/singletons/User';
import { GroupsStore } from '@front-app/store/singletons/Groups';
import { isAdminRole } from '@front-app/util/permission';

export const canRemoveDiscussionMessage = (content: DiscussionMessage): boolean => {
	const { currentUser, isCsr } = CurrentUserStore;
	// You can't remove an already removed item
	if (content.removedAt) {
		return false;
	}
	return isCsr.value
		|| content.sender.id === currentUser.value.id
		|| isAdminRole(GroupsStore.getInstance().groupById(content.groupId)?.role);
};

export const canRestoreDiscussionMessage = (content: DiscussionMessage): boolean => {
	const { currentUser, isCsr } = CurrentUserStore;
	// You can't restore a non-removed item
	if (!content.removedAt) {
		return false;
	}
	return isCsr.value
		|| (content.sender.id === currentUser.value.id && content.removedBySender)
		|| isAdminRole(GroupsStore.getInstance().groupById(content.groupId)?.role);
};

export const canSeeRemovedDiscussionTopic = (content: DiscussionContentItem): boolean => {
	const { currentUser, isCsr } = CurrentUserStore;
	const firstPost = content.metadata.discussion.messages[0];
	return isCsr.value
		|| firstPost.sender.id === currentUser.value.id
		|| isAdminRole(GroupsStore.getInstance().groupById(content.groupId)?.role);
};

export const canSeeRemovedDiscussionMessage = (content: DiscussionMessage): boolean => {
	const { currentUser, isCsr } = CurrentUserStore;
	return isCsr.value
		|| content.sender.id === currentUser.value.id
		|| isAdminRole(GroupsStore.getInstance().groupById(content.groupId)?.role);
};

export const canEditDiscussionMessage = (content: DiscussionMessage): boolean => {
	const { currentUser } = CurrentUserStore;
	return content.sender.id === currentUser.value.id;
};
